/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * В данный момент пока только 1 тип уведомления
 * @export
 * @enum {string}
 */
export enum NotificationType {
  ApplicationStatusChange = 'applicationStatusChange',
  FinishFullCheckResult = 'finishFullCheckResult',
  RegistryExpirationApproaching = 'registryExpirationApproaching',
}

export function instanceOfNotificationType(value: any): boolean {
  for (const key in NotificationType) {
    if (Object.prototype.hasOwnProperty.call(NotificationType, key)) {
      if (NotificationType[key as keyof typeof NotificationType] === value) {
        return true
      }
    }
  }
  return false
}

export function NotificationTypeFromJSON(json: any): NotificationType {
  return NotificationTypeFromJSONTyped(json, false)
}

export function NotificationTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NotificationType {
  return json as NotificationType
}

export function NotificationTypeToJSON(value?: NotificationType | null): any {
  return value as any
}
